<template>
  <section :class="['Grid-layout', 'Search-bar', { 'Search-bar--chip-active': selectedFiltersNumber > 0 }]">
    <div class="Search-bar__content">
      <ux-molecules-search-engine :location="location" is-thin v-if="location" />

      <ux-atoms-button @click="toggleModal" class="Search-bar__button Search-bar__button--filters" size="m" v-if="!hideFiltersBtn" variant="action">
        <ux-atoms-icon class="Search-bar__icon" name="filter" size="m" />
        <ux-atoms-typo :text="$t('ux.molecules.searchBar.filters')" as="span" class="Search-bar__button-text" variant="inherit" />
        <ux-atoms-chip :label="selectedFiltersNumber" class="Search-bar__chip" v-if="selectedFiltersNumber > 0" />
      </ux-atoms-button>

      <ux-atoms-map-list-switch :current-view="currentView" is-desktop />
    </div>
    <Teleport to="#teleports">
      <ux-molecules-modal
        :event-element="modalTarget"
        @close-modal="handleCloseModalEvent"
        button-no-border
        button-position="right"
        has-label-id
        size="half"
        transition="slide"
        v-if="modalTarget"
        v-model="filtersModalIsOpen"
      >
        <template #header>
          <ux-atoms-typo
            :text="$t('ux.molecules.searchBar.filters')"
            as="h2"
            class="Search-bar__modal-header"
            color="dark"
            variant="expressive-heading-04"
          />
        </template>
        <ux-molecules-restaurant-filters current-view="map" />
      </ux-molecules-modal>
    </Teleport>
  </section>
</template>
<script setup lang="ts">
import { SearchFilterInput } from '~/graphql';
import { gtmEvent } from '~/helpers/gtm';

export interface SearchBarProps {
  currentView: 'list' | 'map';
  hideFiltersBtn?: boolean;
  location?: string;
}

const props = withDefaults(defineProps<SearchBarProps>(), {
  currentView: 'list',
  hideFiltersBtn: false,
  location: undefined
});

const { $onAction, $subscribe, calcNumberOfSelectedFilters, updateFilterInput } = searchRestaurantStore();
const { initialFilterInput } = useSearchRestaurant();
const filtersModalIsOpen = ref<boolean>(false);
const selectedFiltersNumber = ref<number>(0);
const modalTarget = ref<HTMLElement | null>(null);

$subscribe((_mutation, state) => {
  selectedFiltersNumber.value = state.numberOfSelectedFilters || 0;
});

const handleCloseModalEvent = () => {
  const defaultFilterInput = initialFilterInput();
  updateFilterInput(defaultFilterInput as SearchFilterInput, true, true);
};

const closeModal = () => {
  filtersModalIsOpen.value = false;
};

$onAction(({ name }) => {
  if (name === 'submitFilterInput') {
    closeModal();
  }
});

const toggleModal = (event: Event) => {
  gtmEvent('more_criteria_open', {
    cta_name: 'filters',
    pagename: `restaurantsandbars::results::${props.currentView}`
  });

  modalTarget.value = event.target as HTMLElement;
  filtersModalIsOpen.value = !filtersModalIsOpen.value;
};

onMounted(() => {
  calcNumberOfSelectedFilters();
});
</script>
<style lang="scss" scoped>
@use 'SearchBar.scss';
</style>
